import React, { useState, useCallback, useEffect } from 'react';

import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import Spinner from "react-bootstrap/Spinner";
import Alert from "react-bootstrap/Alert";

import QuizApi from '../QuizApi';
import { STORAGE_PARTICIPANT_ID, STORAGE_ALIAS, STORAGE_SESSION_SHORT_ID } from '../providers/CourseSessionProvider';

export default function CourseSessionJoin({ courseSessionShortId }) {

  const [alias, setAlias] = useState('');
  const [status, setStatus] = useState('form'); // form | loading | joined | error

  useEffect(() => {

    // A stored participant id only counts as "already joined" if it belongs
    // to THIS kurstillfälle — otherwise a device that joined an earlier
    // (possibly now-ended) session would silently reuse that stale identity
    // instead of actually joining the one this link points to, and never
    // get pushed anywhere since it's not in the current session's room.
    try {
      if (localStorage.getItem(STORAGE_PARTICIPANT_ID)
        && localStorage.getItem(STORAGE_SESSION_SHORT_ID) === courseSessionShortId) {
        setStatus('joined');
      }
    } catch (e) {
      // Ignore storage errors — falls back to the join form.
    }

  }, [courseSessionShortId]);

  const onSubmit = useCallback(async evt => {

    evt.preventDefault();
    if (!alias.trim()) {
      return;
    }

    setStatus('loading');

    const apiResponse = await QuizApi.courseSessionJoin(courseSessionShortId, alias.trim());
    if (!apiResponse || !apiResponse.success || !apiResponse.response) {
      setStatus('error');
      return;
    }

    try {
      localStorage.setItem(STORAGE_PARTICIPANT_ID, apiResponse.response.courseSessionParticipantId);
      localStorage.setItem(STORAGE_ALIAS, apiResponse.response.alias);
      localStorage.setItem(STORAGE_SESSION_SHORT_ID, courseSessionShortId);
    } catch (e) {
      // Ignore storage errors — the join succeeded, but auto-push on this
      // device won't work without somewhere to remember the identity.
    }

    // Reload so CourseSessionProvider (mounted once, above the router) picks
    // up the newly stored participant id and opens its socket connection.
    window.location.reload();

  }, [alias, courseSessionShortId]);

  return (
    <div id="courseSessionJoin" className="bg-purple h-100">
      <Container fluid className="d-flex align-items-center justify-content-center h-100">
        <Row>
          <Col>

            {status === 'form' && (
              <form onSubmit={onSubmit}>
                <h5>Ditt namn</h5>
                <input type="text"
                  className="form-control mb-2"
                  value={alias}
                  autoFocus
                  onChange={ev => setAlias(ev.target.value)}
                />
                <i>Du behöver bara ange detta en gång för hela dagen.</i>
                <br />
                <Button type="submit" className="mt-3" variant="quizPrimary">
                  Klar (gå vidare)
                </Button>
              </form>
            )}

            {status === 'loading' && (
              <div className="d-flex justify-content-center">
                <Spinner animation="border" />
              </div>
            )}

            {status === 'joined' && (
              <div className="text-center">
                <h4>Du är med!</h4>
                <p>Väntar på att föreläsaren startar nästa quiz...</p>
              </div>
            )}

            {status === 'error' && (
              <Alert variant="danger">
                Kunde inte ansluta. Kontrollera länken och försök igen.
              </Alert>
            )}

          </Col>
        </Row>
      </Container>
    </div>
  );
}
